import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEverplacesComponent } from './simple-icons-everplaces.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEverplacesComponent ],
    exports:      [ SimpleIconsEverplacesComponent ],
    bootstrap:    []
})
export class SimpleIconsEverplacesModule {}
